import Cookies from 'js-cookie';

const cookieName = 'cookie-consent';

(($) => {
    if (Cookies.get(cookieName) === undefined) {
        $('.cookie-consent').fadeIn();
        $('.cookie-consent__overlay').fadeIn();

        $('.cookie-consent__submit').on('click', function () {
            const consentEvent = $(this).val();

            Cookies.set(cookieName, consentEvent, { expires: 30 });

            if (consentEvent !== '') {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: consentEvent,
                });

                $('.cookie-consent').fadeOut();
                $('.cookie-consent__overlay').fadeOut();
            }

            window.location.reload();
        });

        $('.cookie-consent__overlay').on('click', function () {
            $('.cookie-consent__submit--necessary').click();
        });

        $('.cookie-consent__close').on('click', function () {
            $('.cookie-consent__submit--necessary').click();
        });
    } else {
        const consentEvent = Cookies.get(cookieName);

        if (consentEvent !== '') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: consentEvent,
            });
        }
    }
})(window.jQuery);
